import routerOptions0 from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_better-sqlite3@12.2.0_db0@0.3.2_be_57cf57ca58b5e8f6d32481655af0ce00/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/apps/lobby/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}